import { Injector } from '@angular/core';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { PartialRawMask } from '../../../shared/state/abstract-sensor-content-state-2d';
import { copyMask, pointsBetween } from '../../utils/mask-utils';
import { AbstractRasterDragHandler } from '../abstract-raster-drag-handler';
import { PaintbrushTool } from './paintbrush-tool';

export class PaintbrushDragHandler extends AbstractRasterDragHandler {
  private tool: PaintbrushTool;
  private initialRawMask: Uint8Array;

  constructor(code: number, initialEvent: MouseEvent, injector: Injector) {
    super(code, initialEvent, injector);
    this.tool = injector.get<PaintbrushTool>(PaintbrushTool);
    // copying the raw mask once to be able to mutate it multiple times, instead
    // of creating a new mask on each mouse move
    this.initialRawMask = copyMask(this.store.getRawMask());
  }

  override startListening() {
    super.startListening();
  }

  onDrag(dragPoint: Point2D, lastPoint: Point2D) {
    const dragPath = pointsBetween(dragPoint, lastPoint);
    this.paintBrushAlong(dragPath);
  }

  protected override complete() {
    this.store('rawMask').set(this.initialRawMask);
    const batchValues = this.getBatchValues();
    this.shellConnector.pushAndTrack({
      ...this.event,
      tool: 'paintbrush',
      ...batchValues.buildEventTrackingValue(),
    });
  }

  private paintBrushAlong(path: Point2D[]) {
    for (const point of path) {
      const partialRawMask = this.tool.paintBrushAt(
        point,
        this.store('partialRawMask'),
        this.code,
      );
      if (partialRawMask) {
        this.applyPartialRawMaskToRawMask(
          partialRawMask,
          this.store.state().sensorRendererState.width,
        );
      }
    }
  }

  private applyPartialRawMaskToRawMask(
    partialRawMask: PartialRawMask,
    width: number,
  ) {
    let index = partialRawMask.yOffset * width + partialRawMask.xOffset;

    partialRawMask.data.forEach((value, partialIndex) => {
      if (partialIndex > 0 && partialIndex % partialRawMask.width === 0) {
        index += width - partialRawMask.width;
      }
      this.initialRawMask[index] = value;
      index++;
    });
  }
}
